import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=0a9aa51b&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"
import style0 from "./AccountSettings.vue?vue&type=style&index=0&id=0a9aa51b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9aa51b",
  null
  
)

export default component.exports